module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reset-password login-form"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('actions.resetPassword.title')))]), _vm._v(" "), _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "newPassword",
      "error": _vm.errors.first('newPassword')
    }
  }, [_c('el-input', {
    attrs: {
      "name": "password",
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.newPassword')
    },
    model: {
      value: (_vm.form.newPassword),
      callback: function($$v) {
        _vm.form.newPassword = $$v
      },
      expression: "form.newPassword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "passwordConfirmation",
      "error": _vm.errors.first('passwordConfirmation')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('placeholder.user.passwordConfirmation')
    },
    model: {
      value: (_vm.form.passwordConfirmation),
      callback: function($$v) {
        _vm.form.passwordConfirmation = $$v
      },
      expression: "form.passwordConfirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary submit-btn"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.resetPassword.submit')))]), _vm._v(" "), _c('span', {
    staticClass: "el-form-item__error"
  }, [_vm._v(_vm._s(_vm.errors.first('custom')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f0919cca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/session/reset_password.view.vue
// module id = 955
// module chunks = 3